import executeUnAuthApi from './executeUnAuthApi ';
import { SystemError, SystemErrorTitle, SystemErrorMsg } from "../../constants";

/** 認証・アクティベーション */
const certificationActivation = async (
    contractId: string,
    contractPass: string,
) => {

    // SmeFrontAPIのURLを取得
    const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
    const apiKey = process.env.REACT_APP_EYES_FRONT_API_KEY!;
    // 認証・アクティベーションAPI PATH
    const path = "/auth/authenticate/execution";
    const request = {
        "contractId": contractId,
        "contractPass": contractPass
    };

    try {
        const response = await executeUnAuthApi(baseURL, apiKey, path, 0, request);
        // レスポンスコード返却
        if (!response || response.data.resCd == "") {
            return {
                resCd: SystemError,
                msgTitle: SystemErrorTitle,
                msg: SystemErrorMsg
            }
        } else {
            return response.data
        }
    } catch (e) {
        return {
            resCd: SystemError,
            msgTitle: SystemErrorTitle,
            msg: SystemErrorMsg
        };
    }
};

export default certificationActivation;
